<mat-table [dataSource]="data"
    matSort
    multiTemplateDataRows
    matSortDisableClear
    matSortActive="fullTitle"
    matSortDirection="asc">

    <!-- More Column -->
    <ng-container matColumnDef="More">
        <mat-header-cell *matHeaderCellDef>
            <span translate>More</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let dataCategory; let j = index">
            <span [ngClass]="{
                'detail-row-expanded-icon': data.checkExpanded(dataCategory),
                'detail-row-collapsed-icon': !data.checkExpanded(dataCategory)
            }"></span>
        </mat-cell>
    </ng-container>

    <!-- Test Column -->
    <ng-container matColumnDef="fullTitle">
        <mat-header-cell mat-sort-header="fullTitle" *matHeaderCellDef style="flex:0 .5 87%;">
            <span translate>Test</span>
            <filter [data]="data" class="mat-filter" columnName="fullTitle" dataType="string"></filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let dataCategory; let j = index" style="flex:0 .5 87%;">
            {{dataCategory.fullTitle}}
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef>
            <span translate>
                Actions
            </span>
        </mat-header-cell>
        <mat-cell *matCellDef="let dataCategory; let j = index">
            <a (click)="addScores($event)">
                Add Scores
            </a>
        </mat-cell>
    </ng-container>

    <!-- Expand Row -->
    <ng-container matColumnDef='expandedRow'>
        <td mat-cell
            class="mat-detail-card detailRow"
            *matCellDef="let dataCategory"
            [attr.colspan]="2">

            <!-- Detail Table -->
            <assessment-data-table [showFilters]="showChildFilters"
                [data]="dataCategory.subTableData"
                [fields]="dataCategory.fields"
                [minTableWidth]="dataCategory.minTableWidth()"></assessment-data-table>
        </td>
    </ng-container>

    <!-- Row definitions -->
    <mat-header-row *matHeaderRowDef="headerColumns"></mat-header-row>
    <mat-row *matRowDef="let row; let j = index; columns: headerColumns;"
        matRipple
        tabindex="0"
        style="cursor: pointer"
        id="tab{{tabIndex}}row{{j}}"
        [ngClass]="{
            'detailRowOpened': data.checkExpanded(row),
            'selectedRow': selectedRow == row}"
        [attr.aria-label]="row.fullTitle + ' results. Press enter to toggle details.'"
        (click)="rowClick(row)"></mat-row>
    <mat-row *matRowDef="let row; columns: ['expandedRow']"
        matRipple
        class="mat-detail-row"
        (click)="selectedRow = row;"
        [ngStyle]="{'background-color': selectedRow == row ? 'whitesmoke' : ''}"
        [@detailExpand]="data.checkExpanded(row) ? 'expanded' : 'collapsed'"
        style="overflow: hidden"></mat-row>
</mat-table>
